import React, {
  FC,
  useMemo,
  useEffect,
  useState,
  useContext,
  useCallback,
} from "react";
import ContentModal from "@pixel/core/ContentModal";
import LayoutRootSection from "@pixel/internal/LayoutRootSection";
import Typography from "@mui/material/Typography";
import TableChartIcon from "@pixel/assets/icons/TableChart";
import ListBase, { ListSearchChangeProps } from "@pixel/core/ListBase";
import DataTable from "@pixel/core/DataTable";
import Box from "@pixel/core/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Radio from "@pixel/core/Radio";
import RadioGroup from "@pixel/core/RadioGroup";
import FormControlLabel from "@pixel/core/FormControlLabel";
import FormControl from "@pixel/core/FormControl";
import {
  IReqsResultData,
  IPayloadParams,
  IReqsData,
  IActionModalProps,
} from "../../types/candidates";
import CandidateListContext from "../../contexts/candidate/candidateListContext";
import {
  transformReqsFilterData,
  reqsListStatusFilter,
  reqsListCategoryFilter,
  transformReqsListData,
} from "../../utils/candidateResultTransform";
import axios from "axios";
import { useSnackbar } from "@pixel/core/SnackbarService";
import RejectCandidateModal from "./RejectModal";
import { ListBaseDefaultLoading } from "../ListBaseDefaultLoading";
import FloatingCircularProgress from "./FloatingCircularProgress";

const overflowStyle = {
  width: 'auto',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}

const MoveCandidateModal: FC<IActionModalProps> = ({ open, onClose }) => {
  const snack = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [perPageCount, setPerPageCount] = useState(10);
  const [mainModalOpen, setMainModalOpen] = useState(open)
  const [openModal, setOpenModal] = useState(false);
  const [moveAcrossCandEnabled, setMoveAcrossCandEnabled] = useState(
      window.properties.enableMoveCandidate
  );
  const [movedCandidates, setMovedCandidates] = useState({});
  const [openMoveAcrossModal, setOpenMoveAcrossModal] = useState(false);
  const [
    moveCandidateForSameWorkflow,
    setMoveCandidateForSameWorkflow,
  ] = React.useState(false);
  const [rejectOrMove, setRejetOrMove] = useState("");
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const handleClose = (event: any, reason: any) => {
    if (reason && reason == "backdropClick") return;
    setOpenModal(false);
    setMovedCandidates({});
    setMoveCandidateAcrossWorkflows(false);
    onClose()
  };

  const closeRejectModal = () => {
    setOpenRejectModal(false);
    onClose();
  };

  const moveRejectCandidateAcross = () => {
    if (rejectOrMove === "reject") {
      setOpenRejectModal(true);
    } else if (rejectOrMove === "move") {
      setIsSubmitting(true)
      let postData = {
        destinationJobId: selected[0],
        data: candidateContext.selectedCandidate,
      };
      candidateContext.props.candidateService.moveCandidateForSameWorkflow(
        postData,
        function (response: any) {
          setIsSubmitting(false)
          if (response.data.msgInfo && response.data.msgInfo !== 200) {
            snack.showError(candidateContext.props.translations.SERVER_ERROR);
          } else {
            if (Object.keys(response.data.notmoved).length > 0) {
              setOpenModal(true);
              setMoveCandidateForSameWorkflow(true);
              setMovedCandidates(response.data);
            } else {
              let successText =
                candidateContext.selectedCandidate.length > 1
                  ? candidateContext.props.translations
                      .DUPLICATE_MODAL_TITLE_MULTIPLE
                  : candidateContext.props.translations
                      .DUPLICATE_MODAL_TITLE_SINGLE;
              snack.showSuccess(successText);
              onClose();
            }
          }
        }
      );
    }
  };
  const initialReqsPayload: IPayloadParams = {
    page: 0,
    q: null,
    maxResult: perPageCount,
    jobStateValue: 1,
    mine: null,
    categoryIds: null,
  };
  const [results, setCandidateResult] = useState<IReqsResultData>({
    nodes: [],
    totalCount: 0,
    resultsCount: 0,
    showCompany: null,
  });
  const [reqsPayload, setReqsPayload] = useState<IPayloadParams>(
    initialReqsPayload
  );
  const [totalCandidates, setTotalCandidates] = useState(0);
  const [
    moveCandidateAcrossWorkflows,
    setMoveCandidateAcrossWorkflows,
  ] = useState(false);
  const candidateContext = useContext(CandidateListContext);
  const baseReqsURL = window.jvUrls.jhire + "/action/requisitions";
  const handleResolve = () => {
    if (!moveAcrossCandEnabled) {
      setIsSubmitting(true)
      let addCandPayload = {
        destinationJobId: selected[0],
        sourceJobId: candidateContext.reqsEId,
        data: candidateContext.selectedCandidate,
      };
      try {
        candidateContext.props.candidateService.moveCandidate(
          addCandPayload,
          (response: any) => {
            setIsSubmitting(false)
            if (response.data.msgInfo !== 200) {
              snack.showError(candidateContext.props.translations.SERVER_ERROR);
            } else {
              if (Object.keys(response.data.notmoved).length > 0) {
                setOpenModal(true);
                setMovedCandidates(response.data);
                setMainModalOpen(false);
              } else {
                let successText =
                  candidateContext.selectedCandidate.length > 1
                    ? candidateContext.props.translations
                        .DUPLICATE_MODAL_TITLE_MULTIPLE
                    : candidateContext.props.translations
                        .DUPLICATE_MODAL_TITLE_SINGLE;
                snack.showSuccess(successText);
                onClose()
              }
            }
          }
        );
      } catch (error) {
        setIsSubmitting(false)
        console.log(error);
      }
    } else {
      if (candidateContext.validatedCandidateList.moveAcrossDiffWorkflows) {
        setOpenMoveAcrossModal(true);
        setMoveCandidateAcrossWorkflows(true);
        setMainModalOpen(false);
      } else {
        var args = {
          destinationJobId: selected[0],
          data: candidateContext.selectedCandidate[0],
          CandidateListPage: false, // need to update based on page later
        };
        candidateContext.props.candidateService.validateMoveModal(
          args,
          function (response: any) {
            setMoveCandidateAcrossWorkflows(
              response.data.moveAcrossDiffWorkflows
            );
            setOpenMoveAcrossModal(true);
            setMainModalOpen(false);
          }
        );
      }
    }

    return true
  };

  useEffect(() => {
    async function fetchRequisitions() {
      try {
        setLoading(true)
        axios
          .get(baseReqsURL, {
            params: reqsPayload,
          })
          .then((response) => {
            setLoading(false)
            setCandidateResult(transformReqsListData(response.data));
            setTotalCandidates(response.data.jobCount);
            setPagingContext({
              hideFirstLastActions: true,
              perPage: perPageCount,
              page: reqsPayload.page + 1,
              first:
                response.data.jobCount > 0
                  ? reqsPayload.page * perPageCount + 1
                  : 0,
              last: perPageCount * reqsPayload.page + response.data.jobs.length,
            });
          });
      } catch (error) {
        setLoading(false)
        console.log(error);
      }
    }
    fetchRequisitions();
  }, [reqsPayload]);

  useEffect(() => {
    async function populateReqsModal() {
      try {
        await candidateContext.props.candidateService.getRequistionFilters(
          null,
          (response: any) => {
            if (response.status === 200 && response.data) {
              transformReqsFilterData(response.data);
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    }
    populateReqsModal();
  }, []);

  const handleCloseMoveAcross = useCallback((event: any, reason: any) => {
    if (reason === "backdropClick") return;
    setOpenMoveAcrossModal(false);
  }, []);

  const handleRejectMoveChange = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        setRejetOrMove(event.target.value);
      },
      []
  );

  const resolveMoveAcross = useCallback(() => {
    setOpenMoveAcrossModal(false);
  }, []);

  useEffect(() => {
    if (rejectOrMove != "" && !openMoveAcrossModal) {
      moveRejectCandidateAcross();
    }
  }, [openMoveAcrossModal, rejectOrMove]);

  const handleSearch = (props: ListSearchChangeProps) => {
    let updatePayload: IPayloadParams = {
      page: 0,
      q: props.q ? props.q : null,
      maxResult: 10,
      jobStateValue: null,
      mine: null,
      categoryIds: null,
    };
    props.appliedSearchFilters.forEach((property: any) => {
      if (property && property.searchFilterId === "category") {
        updatePayload.categoryIds = property.filterValues[0].value;
      } else {
        updatePayload.mine = property.filterValues[0].mine;
        updatePayload.jobStateValue = property.filterValues[0].value;
      }
    });
    setReqsPayload(updatePayload);
  };

  const searchFitlerStatus = useMemo(
    () => ({
      id: "status",
      label: candidateContext.props.translations.STATUS,
      type: "single_select",
      options: reqsListStatusFilter,
    }),
    []
  );

  const searchFitlerCategory = useMemo(
    () => ({
      id: "category",
      label: candidateContext.props.translations.CATEGORY,
      type: "single_select",
      options: reqsListCategoryFilter,
    }),
    []
  );

  const appliedSearchFilterStatus = useMemo(
    () => ({
      searchFilterId: "status",
      displayLabel: candidateContext.props.translations.STATUS + ": Open",
      filterValues: [{ value: 1, label: "Open" }],
    }),
    []
  );

  const [appliedSearchFilters, setAppliedSearchFilters] = useState([
    appliedSearchFilterStatus,
  ]);
  const searchFilters = [searchFitlerStatus, searchFitlerCategory];
  const [selected, setSelected] = useState<Array<IReqsData["EId"]>>([]);

  const handleSelection = useCallback(
    (node: IReqsData, nextSelectedState: boolean) => {
      setSelected([node.EId]);
    },
    [selected, setSelected]
  );

  const [pagingContext, setPagingContext] = useState({
    hideFirstLastActions: true,
    perPage: perPageCount,
    page: 0,
    first: 0,
    last: totalCandidates <= perPageCount ? totalCandidates : perPageCount,
  });

  const onPaginationChange = (event: any, currPage: number) => {
    setReqsPayload({
      ...reqsPayload,
      page: currPage - 1,
    });
  };

  return (
    <div>
      <ContentModal
        id="move-candidate"
        open={open && mainModalOpen}
        onClose={onClose}
        showClose={true}
        sizeVariant="xl"
        title={candidateContext.props.translations.CANDIDATES_MOVE_MODAL_TITLE}
        labelCloseAria={candidateContext.props.translations.CLOSE}
        rejectActions={[
          {
            reason: "cancel",
            label: candidateContext.props.translations.HIRE_CANCEL,
          },
        ]}
        resolveActions={[
          {
            reason: "ok",
            label:
              candidateContext.props.translations.ADMIN_TAG_CANDIDATE_MOVE_CAND,
            disabled: !selected.length
          },
        ]}
        onResolve={handleResolve}
      >
        <FloatingCircularProgress open={isSubmitting} />
        <LayoutRootSection top transparent>
          <Typography variant="body2" sx={{ pb: 2 }}>
            {candidateContext.selectedCandidate.length +
              " " +
              candidateContext.props.translations.I18N_CANDIDATES_COMMON +
              " " +
              candidateContext.props.translations.I18N_CANDIDATES_MOVE_MSG}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 600, pb: 2 }}>
            {
              candidateContext.props.translations
                .APPLICANT_JOBLIST_SELECT_A_REQUISITION
            }
          </Typography>
          <ListBase
            results={results}
            showSearch={true}
            labelSearch={candidateContext.props.translations.SEARCH}
            labelSearchAria={candidateContext.props.translations.SEARCH}
            // @ts-ignore
            nodeIdKey="EId"
            selectedIds={selected}
            onSearch={handleSearch}
            selectable
            onSelection={handleSelection}
            selectionType="single"
            searchFilters={searchFilters}
            appliedSearchFilters={appliedSearchFilters}
            pagingContext={pagingContext}
            onPageChanged={onPaginationChange}
            resultsLoading={loading}
            viewContexts={[
              {
                ariaLabel:
                  candidateContext.props.translations.ADD_TO_REQUISITION,
                icon: <TableChartIcon />,
                renderResults: (viewContextProps) => (
                  <DataTable
                    {...viewContextProps}
                    getRowID={(node) => node.EId}
                    columns={[
                      {
                        id: "requisitions",
                        columnName:
                          candidateContext.props.translations
                            .COMMON_REQUISITIONS,
                        minWidth: 80,
                        maxWidth: 300,
                        renderCell: (node) => (
                          <Typography variant="body2" sx={{ fontWeight: 600, ...overflowStyle }}>
                            {node.title}
                          </Typography>
                        ),
                      },
                      {
                        id: "id",
                        columnName:
                          candidateContext.props.translations.ADDTOREQ_ID,
                        renderCell: (node) => (
                          <Typography variant="body2">
                            {node.requisitionId}
                          </Typography>
                        ),
                        minWidth: 80,
                      },
                      {
                        id: "status",
                        columnName: candidateContext.props.translations.STATUS,
                        renderCell: (node) => (
                          <Typography variant="body2">
                            {node.jobState}
                          </Typography>
                        ),
                        minWidth: 150,
                      },
                      {
                        id: "category",
                        columnName:
                          candidateContext.props.translations.CATEGORY,
                        renderCell: (node) => (
                          <Typography variant="body2">
                            {node.category && node.category.name}
                          </Typography>
                        ),
                        minWidth: 150,
                      },
                      {
                        id: "locations",
                        columnName:
                          candidateContext.props.translations.COMMON_LOCATION,
                        renderCell: (node) => (
                          <Typography variant="body2">
                            {node.location && node.location.name}
                          </Typography>
                        ),
                        minWidth: 80,
                      },
                    ]}
                    labelCheckboxAriaLabel="Select candidate with name {label}"
                    labelCheckboxKey="name"
                  />
                ),
                renderLoading: () => (
                  <ListBaseDefaultLoading />
                ),
              },
            ]}
          />
        </LayoutRootSection>
      </ContentModal>
      {openModal && (!moveAcrossCandEnabled || moveCandidateForSameWorkflow) && (
        <ContentModal
          id="move-candidate-confirmation"
          open={openModal}
          onClose={handleClose}
          showClose={true}
          sizeVariant="xs"
          title={
            movedCandidates.count == 0
              ? candidateContext.props.translations.DUPLICATE_MODAL_TITLE_SINGLE
              : candidateContext.props.translations
                  .DUPLICATE_MODAL_TITLE_MULTIPLE
          }
          labelCloseAria={candidateContext.props.translations.CLOSE}
          rejectActions={[
            {
              reason: "cancel",
              label: candidateContext.props.translations.HIRE_CANCEL,
            },
          ]}
          resolveActions={[
            {
              reason: "ok",
              label: candidateContext.props.translations.COMMON_OK,
            },
          ]}
          onResolve={handleClose}
        >
          <FloatingCircularProgress open={isSubmitting} />
          <Box>
            <Typography id="keep-mounted-modal-description">
              {movedCandidates.count == 0
                ? candidateContext.props.translations
                    .CANDIDATES_NOT_MOVED_TO_REQ +
                  " " +
                  candidateContext.props.translations
                    .CANDIDATES_ALREADY_ASSOCIATED_TO_REQ
                : movedCandidates.count +
                  " " +
                  candidateContext.props.translations
                    .DUPLICATE_MODAL_TITLE_MULTIPLE +
                  " " +
                  candidateContext.props.translations
                    .CANDIDATES_ALREADY_ASSOCIATED_TO_REQ}
            </Typography>
            <List sx={candidateContext.modalStyle.listStyle}>
              {Object.keys(movedCandidates.notmoved || {}).map((key, index) => (
                <ListItem
                  key={key}
                  disableGutters
                  sx={candidateContext.modalStyle.itemStyle}
                >
                  <ListItemText primary={`${movedCandidates.notmoved[key]}`} />
                </ListItem>
              ))}
            </List>
          </Box>
        </ContentModal>
      )}
      {openMoveAcrossModal && moveAcrossCandEnabled && (
        <ContentModal
          id="move-candidate-across-confirmation"
          open={openMoveAcrossModal}
          onClose={handleCloseMoveAcross}
          showClose={true}
          sizeVariant="md"
          title={
            candidateContext.props.translations
              .APPLICANT_APPLICANTGRID_MOVE_CANDIDATE
          }
          labelCloseAria={candidateContext.props.translations.CLOSE}
          rejectActions={[
            {
              reason: "cancel",
              label: candidateContext.props.translations.HIRE_CANCEL,
            },
          ]}
          resolveActions={[
            {
              reason: "ok",
              label: candidateContext.props.translations.COMMON_MOVE,
              disabled: !rejectOrMove
            },
          ]}
          onReject={onClose}
          onResolve={resolveMoveAcross}
        >
          <FloatingCircularProgress open={isSubmitting} />
          <FormControl margin="normal">
            <Typography variant="body2" sx={{ fontWeight: 600, mb: 2 }}>
              {candidateContext.props.translations.CANDIDATES_MOVE_OPTION_LABEL}{" "}
              :
            </Typography>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              value={rejectOrMove}
              onChange={handleRejectMoveChange}
              name="radio-buttons-group"
            >
              <FormControlLabel
                value="reject"
                control={<Radio size="small" />}
                label={
                  candidateContext.props.translations
                    .CANDIDATES_MOVE_OPTION_REJECT
                }
              />
              <Typography
                variant="caption"
                sx={{
                  color: "gray",
                  pl: 3.5,
                  mb: 2,
                }}
              >
                {candidateContext.props.translations.I18N_REJECT_MODAL_LABEL}
              </Typography>
              <FormControlLabel
                disabled={moveCandidateAcrossWorkflows}
                value="move"
                control={<Radio size="small" />}
                label={
                  candidateContext.props.translations
                    .CANDIDATES_MOVE_OPTION_DELETE
                }
              />
              <Typography
                variant="caption"
                sx={{
                  color: "gray",
                  pl: 3.5,
                }}
              >
                {candidateContext.props.translations.I18N_DELETE_MODAL_LABEL}
              </Typography>
            </RadioGroup>
          </FormControl>
        </ContentModal>
      )}
      {openRejectModal && (
        <RejectCandidateModal
          open={openRejectModal}
          onClose={closeRejectModal}
          destinationJobId={selected[0]}
        ></RejectCandidateModal>
      )}
    </div>
  );
};

export default MoveCandidateModal;
